import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getLovdData } from "../../../../state/selectors/Lovd.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { effectStrings } from "../../../../pages/variant/components/Lovd/components/constants";
import {
  capitalizeFirstLetterOfEachWord,
  DEFAULT_COLOR,
} from "../../../../common/helpers/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { getPathogenicityAndEffect } from "./helpers";

const LovdCard = ({ card, lovdData }) => {
  const isDisabled = !lovdData || !Object.keys(lovdData[0] || {}).length;
  const [pathogenicity, effect] = getPathogenicityAndEffect(lovdData);
  const color =
    lovdData && lovdData.length > 0 && pathogenicity
      ? getPathogenicityColorByAllNames(pathogenicity)
      : DEFAULT_COLOR;

  const renderPathogenicity = () => {
    if (lovdData && lovdData.length > 0 && pathogenicity) {
      return (
        <span style={{ color }} data-testid="lovd-card-pathogenicity">
          <b>{capitalizeFirstLetterOfEachWord(pathogenicity)}</b>
        </span>
      );
    }
    return null;
  };

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={color}
      secondaryTitle={renderPathogenicity()}
    >
      {effect && (
        <div data-testid="lovd-card-effect">
          <small>{effectStrings[effect]}</small>
        </div>
      )}
    </CardWrapper>
  );
};

LovdCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  lovdData: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      genes: PropTypes.arrayOf(
        PropTypes.shape({
          gene_id: PropTypes.number,
          hgnc_id: PropTypes.number,
          gene_symbol: PropTypes.string,
        })
      ),
      individuals: PropTypes.arrayOf(
        PropTypes.shape({
          comments: PropTypes.arrayOf(PropTypes.string),
          gender: PropTypes.string,
          phenotypes: PropTypes.arrayOf(PropTypes.string),
          pub_med_references: PropTypes.arrayOf(PropTypes.number),
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              comments: PropTypes.arrayOf(PropTypes.string),
              is_current: PropTypes.bool,
              is_lifted_over: PropTypes.bool,
              lovd_link: PropTypes.string,
              pathogenicity: PropTypes.shape({
                clinical_classification_submitter: PropTypes.string,
                clinical_classification_curator: PropTypes.string,
                effect_submitter: PropTypes.string,
                effect_curator: PropTypes.string,
                effect_symbol: PropTypes.string,
              }),
              variant_info: PropTypes.arrayOf(
                PropTypes.shape({
                  variant_id: PropTypes.string,
                  variant_notation: PropTypes.string,
                })
              ),
            })
          ),
        })
      ),
      pathogenicities: PropTypes.arrayOf(
        PropTypes.shape({
          clinical_classification_submitter: PropTypes.string,
          clinical_classification_curator: PropTypes.string,
          effect_submitter: PropTypes.string,
          effect_curator: PropTypes.string,
          effect_symbol: PropTypes.string,
        })
      ),
    })
  ),
};

LovdCard.defaultProps = {
  lovdData: [],
};

const mapStateToProps = (state) => ({
  lovdData: getLovdData(state),
});

export default connect(mapStateToProps)(LovdCard);
